import { ENG, EST, FIN, LAV, LIT, RUS } from 'src/constants/languages';
export default {
    allowedLanguages: [
        ENG,
        EST,
        RUS,
        LIT,
        LAV,
        FIN
    ],
    loginPageAllowedLanguages: [
        ENG,
        EST,
        RUS
    ],
    defaultLanguage: EST
};
